import { Img, Main, MainForm, MainLayoutWrapper } from './styles'

const MainLayout = ({ children }) => (
  <MainLayoutWrapper>
    <Main>
      <Img />
      <MainForm data-testid="main-form">{children}</MainForm>
    </Main>
  </MainLayoutWrapper>
)

export { MainLayout }
